.badge-override {
  border-radius: 2px;
}
